import AiApiSettingsTab from './ai-api-settings';

export default AiApiSettingsTab;
